import React from 'react';
import Dashboard from './Dashboard';

// All jurisdictions but 30, which is Analyst findings
const ResponderPage = props => (
  <Dashboard
    title="Responder Dashboard"
    withoutJurisdiction="30"
    {...props}
  />
);

export default React.memo(ResponderPage);



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/Responder.js